'use strict';

const moment = require('moment');

angular.module('mean.accounting').controller('ChartController',
    ['$scope', '$http', 'Global', 'MeanUser', 'accountingConstant', 'ngDialog', 'commonConstant', 'Charts', 'Users', 'toaster', 'userService', '$filter', '$timeout',
        function ($scope, $http, Global, MeanUser, accountingConstant, ngDialog, commonConstant, Charts, Users, toaster, userService, $filter, $timeout) {
            $scope.global = Global;
            $scope.user = MeanUser.user;
            $scope.accountingConstant = accountingConstant;
            $scope.idle = $scope.accountingConstant.idleTime;
            $scope.timeout = $scope.accountingConstant.timeoutTime;
            $scope.addAccountObj = null;
            $scope.commonConstant = commonConstant;
            $scope.minDateMoment = moment();
            $scope.accountsList = [];
            $scope.accountTypeList = accountingConstant.accountType;
            $scope.statusType = accountingConstant.status;
            $scope.accountType = [];
            $scope.detailType = [];
            $scope.mainAccountList = [];
            $scope.sortReverse = false;
            var importAPI = '/api/accounting/importChart';
            $scope.fiscalYear = null;
            console.log("$scope.user", $scope.user);
            $scope.init = function () {
                $scope.accountType = $scope.accountTypeRecusion($scope.accountTypeList);
                userService.getMainAccountId($scope.user.username).then(function (id) {
                    $scope.clientAccountId = id;
                    $scope.getAllChartAct();
                });
                Users.query({
                    'username': $scope.user.username,
                }, function (users) {
                    $scope.fiscalYear = moment(users[0].fiscalYear).toDate();
                })
            };

            $scope.updateFiscalYear = function(newValue, oldValue) {
                Users.query({
                    'username': $scope.user.username,
                }, function (users) {
                    $scope.fiscalYear = newValue.toDate();
                    users[0].fiscalYear = newValue.startOf('day').toDate();
                    users[0].$update();
                })
            }

            $scope.fiscalYearDate = function() {
                var dateData = moment($scope.fiscalYear).format('MMMM DD');
                return dateData;
            }

            $scope.isSelectable = function (date, type) {
                return !(type == 'day' && date.isLeapYear() && date.format('MM') === '02' && date.format('DD') === '29');
            };

            /**
             * @description toggleChart
             * @param {object} data
             */
            $scope.toggleChart = function(data) {
                if (data.hasOwnProperty('expended')){
                    data['expended'] = !data['expended'];
                    if (data.hasOwnProperty('childItem') && data.childItem.length) {
                        data.childItem.map(function(item) {
                            if (item.hasOwnProperty('expended')){
                                item.expended = !!item.expended ? false : item.expended
                                if (item.childItem && item.childItem.length) {
                                    item.childItem.map(function(sub){
                                        if (sub.hasOwnProperty('expended')){
                                            sub.expended = !!sub.expended ? false : sub.expended;
                                            if (sub.childItem && sub.childItem.length) {
                                                sub.childItem.map(function(sub1){
                                                    if (sub1.hasOwnProperty('expended')){
                                                        sub1.expended = !!sub1.expended ? false : sub1.expended;
                                                    }
                                                })
                                            }
                                        }
                                    })
                                }
                            }
                        })
                    }
                } else {
                    data['expended'] = true;
                }
            }

            $scope.getAllChartAct = () => {
                var chartQuery = { type: 'All', isDeleted: false, userId: $scope.clientAccountId };
                if ($scope.status) {
                    chartQuery.status = true;
                }
                Charts.query(chartQuery, function (accounts) {
                    $scope.allAccounts = accounts;
                    $scope.accountsList = getAccountList(accounts);
                });
            }

            /**
             * @description get the list of accounts  wrt to childItems.
             * @param {object} accounts
             * @return listData object with childItems
             */
            function getAccountList(accounts) {
                var listData = accounts.filter(item => item.isSubAccount == 0).map(e => {
                    e.childItem = [];
                    return e;
                });
                listData = makeChildElements(listData, accounts);
                return listData;
            }

            function makeChildElements(listData, accounts) {
                for(var i=0; i < listData.length; i++ ) {
                    listData[i]['childItem'] = [];
                    for (var j=0; j < accounts.length; j++) {
                        if (accounts[j].isSubAccount == 1) {
                            var index = listData.findIndex(item => item._id == accounts[j].mainAccount._id);
                            if (index >= 0) {
                                if (listData[index].hasOwnProperty('childItem')) {
                                    var index2 = listData[index]['childItem'].filter(item => item._id == accounts[j]._id);
                                    if(!index2.length) {
                                        listData[index]['childItem'].push(accounts[j]);
                                    }
                                }
                            }
                        }
                    }
                    if(listData[i].childItem.length) {
                        makeChildElements(listData[i].childItem, accounts);
                    }
                }
                return listData;
            }

            /**
             * @description for getting the formatted accountType
             */
            $scope.accountTypeRecusion = (data) => {
                for (var obj of data) {
                    if (obj.hasOwnProperty('type')) {
                        $scope.accountTypeRecusion(obj.type, obj.name)
                    }
                    (obj.parent) && $scope.accountType.push({
                        accountType: obj.name,
                        parent: obj.parent,
                        parentOfParent: obj.parentOfParent,
                        name: obj.name + ' (' + obj.parent + ')',
                        detailType: obj.detailType
                    });
                }
                return $scope.accountType;
            };

            /**
             * @description getting the list of main account those are existing with combination of accountType and detailType
             */
            $scope.onChange = (type) => {
                $scope.mainAccountList = []
                if (type.accountType.accountType) {
                    Charts.query({
                        type: 'MAIN_ACCOUNT',
                        isDeleted: false,
                        accountType: type.accountType.accountType,
                        userId: $scope.clientAccountId,
                        status: 'Active'
                    }, function (accounts) {
                        $timeout(function(){
                            $scope.mainAccountList = accounts;
                            if (!type.isNew) {
                                $scope.mainAccountList = $scope.mainAccountList.filter(function(item){
                                    return item._id !== type._id;
                                });
                            }
                        }, 0);
                    });
                }
            }

            /**
             *  @description add the new account
             */
            $scope.AddAccountView = () => {
                $scope.addAccountObj = { isSubAccount: 0, status: 'Active', isNew: true, asOf: moment().toDate() }
                ngDialog.openConfirm({
                    template: 'accounting/views/charts/addAccount.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg',
                }).then(function (value) {
                    var parentsOfParentsAC = value.accountType.parentOfParent
                            ? value.accountType.parentOfParent
                                : value.mainAccount ? value.mainAccount.parentOfAccountType : null;

                    if (value.mainAccount && value.mainAccount.name === 'Retained Earnings') {
                        toaster.pop('error', 'Error', 'Retained Earnings chart of account restrict to 1 level.');
                        $scope.getAllChartAct();
                        return;
                    }

                    var chart = new Charts({
                        clientAccountId: $scope.clientAccountId,
                        userId: $scope.user._id,
                        accountType: value.accountType.accountType,
                        detailType: value.detailType,
                        parentOfAccountType: value.accountType.parent,
                        parentOfParentAccountType: parentsOfParentsAC,
                        name: value.name,
                        description: value.description,
                        isSubAccount: value.isSubAccount,
                        mainAccount: value.mainAccount ? value.mainAccount._id : null,
                        level: value.mainAccount ? value.mainAccount.level + 1: 0,
                        asOf: value.asOf._d,
                        balance: value.balance,
                        status: value.status
                    });
                    if (chart.level == 5) {
                        toaster.pop('error', 'Error', 'Chart child level limit not supported more than 5 level.');
                        $scope.getAllChartAct();
                        return;
                    }
                    chart.$save(function () {
                        $scope.getAllChartAct();
                        toaster.pop('success', 'Added', 'Account Added Successfully.');
                    }, function(err){
                        toaster.pop('error', 'Error', err.data.error);
                        $scope.getAllChartAct();
                    });
                },function(){
                    $scope.getAllChartAct();
                    $scope.mainAccountList = [];
                });
            };

            /**
             * @description Edit the chart account
             */
            $scope.editChartAccount = ($event, indexValue, account) => {
                $event.stopPropagation();
                var accountObj = account;
                accountObj.accountType = $scope.accountType.filter(item => item.accountType === accountObj.accountType)[0];
                accountObj.asOf = moment(accountObj.asOf);
                accountObj.isNew = false;
                $scope.addAccountObj = accountObj;
                $scope.onChange(account)
                ngDialog.openConfirm({
                    template: 'accounting/views/charts/addAccount.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg',
                    onOpenCallback: function(){
                        Charts.query({
                            type: 'MAIN_ACCOUNT',
                            isDeleted: false,
                            accountType: accountObj.accountType.accountType,
                            userId: $scope.clientAccountId,
                            status: 'Active'
                        }, function (accounts) {
                            if ($scope.addAccountObj.mainAccount) {
                                $scope.mainAccountList = accounts;
                                $scope.addAccountObj.mainAccount = $scope.mainAccountList.filter(item => item._id == accountObj.mainAccount._id)[0];
                            }
                            if (!accountObj.isNeww) {
                                $scope.mainAccountList = $scope.mainAccountList.filter(function(item){
                                    return item._id !== accountObj._id;
                                });
                            }
                        });
                    }
                }).then(function (value) {
                    value.parentOfAccountType = value.accountType.parent;
                    value.parentOfParentAccountType = value.accountType.parentOfParent;
                    value.accountType = value.accountType.accountType;
                    if (value.isSubAccount == '1') {
                        value.level = value.mainAccount.level + 1;
                    }
                    value.mainAccount = value.isSubAccount == '1' ? value.mainAccount._id : null;
                    
                    if (value.level == 5) {
                        toaster.pop('error', 'Error', 'Chart child level limit not supported more than 5 level.');
                        $scope.getAllChartAct();
                        return;
                    }
                    value.$update(function () {
                        $scope.getAllChartAct();
                        toaster.pop('success', 'Updated', 'Account Updated Successfully.');
                    }, function(err){
                        toaster.pop('error', 'Error', err.data.error);
                        $scope.getAllChartAct();
                    });
                }, function() {
                    $scope.getAllChartAct();
                    $scope.mainAccountList = [];

                });

            };

            /**
             * @description delete the chart account
             */
            $scope.deleteChartAccount = ($event, indexValue, account) => {
                $event.stopPropagation();
                $scope.PopupHeading = 'Chart Delete';
                ngDialog.openConfirm({
                    template: 'accounting/views/tmpl/confirmationPopup.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-sm'
                }).then(function (value) {
                    Charts.query({ type: 'IS_ASSOCIATE', id: account._id, userId: $scope.clientAccountId }, function (accounts) {
                        if (accounts.length) {
                            toaster.pop('error', 'Account Associate', 'This account already associated with another account.');
                            return;
                        } else {
                            account.isDeleted = true;
                            account.$update(function (response) {
                                toaster.pop('success', 'Deleted', response.message);
                                $scope.getAllChartAct()
                            }, function (response) {
                                toaster.pop('error', 'Error', response.data.error);
                                $scope.getAllChartAct()
                            });
                        }

                    });
                }, $scope.getAllChartAct);
            };

            /**
             * @description convert to csv
             */
            $scope.ConvertToCSV = function (objArray) {
                var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
                var str = 'Account Type, Detail Type, Name, Description, Parent Account, Starting Balance, As Of';
                str += '\r\n';

                for (var i = 0; i < array.length; i++) {
                    str += (array[i].accountType || '') + ', ' + (array[i].detailType || '') + ', ' + (array[i]['name'] || '') + ',';
                    str += (array[i].description || '') + ', ' + (array[i].mainAccount ? array[i].mainAccount.name : '') + ', ';
                    str += (array[i].balance || '') + ', ' + (moment(array[i].asOf).format('MM/DD/YYYY') || '');
                    str += '\r\n';
                }
                var uri = encodeURIComponent(str);
                return uri;
            };

             /**
             * @description export csv file
             */
            $scope.exportFile = function () {
                var dataUrl = 'data:text/csv;charset=utf-8,' + ($scope.ConvertToCSV($scope.allAccounts));
                var link = document.createElement('a');
                angular.element(link)
                    .attr('href', dataUrl)
                    .attr('download', 'chart_of_accounts_report.csv'); // Pretty much only works in chrome
                link.click();
            };
            
            /**
             * @description import selected file
             */
            $scope.fileSelected = function () {
                var payload = {},
                    _self = this,
                    importedCsv = this.$parent.fileContent.split('\n'),
                    headerLength = importedCsv[0].split(',').length;
                    if (headerLength == 7) {
                        for (var i = 1 ; i < importedCsv.length - 1; i++) {
                            var l = importedCsv[i],
                                data = l.split(',');
                            if (!!data[6].trim()) {
                                if (new Date(data[6].trim()) !== 'Invalid Date') {
                                    data[6] = new Date(data[6].trim());
                                }
                            }
                            importedCsv[i] = data.join();
                        }
                    }
                payload.userId = $scope.clientAccountId;
                payload.charts = importedCsv;
                $http.post(importAPI, payload).
                success(function () {
                    toaster.pop('success', 'Data imported successfully.');
                    $scope.getAllChartAct();
                    delete _self.$parent.fileContent;
                }).
                error(function (error) {
                    var title = 'Rejected Import, fix, and retry.',
                        message = '';
                    if (error.error.length) {
                        var linenumber = 0
                        error.error.map( function(error, index) {
                            linenumber = index + 1;
                            var errormsg = '<b>'+ linenumber + '. ' + error + '.</b> <br><br>' ;
                            message = message.concat(errormsg);
                        });
                        var height = linenumber > 10 ? 500 : 50 * linenumber;
                            height = height + 'px';
                        message = '<div class="toster-msg-trans" style="height:'+height+'">' + message + '</div>' 
                    } else {
                        message = error;
                    }
                    toaster.pop({
                        'type': 'error',
                        'title': title, 
                        'body': message,
                        'bodyOutputType': 'trustedHtml',
                        'timeout': 0,
                        'showCloseButton': true
                    });
                    $scope.getAllChartAct();
                    delete _self.$parent.fileContent;
                });
            };
            
            $scope.changeValue = function () {
                $scope.status = this.status;
                $scope.getAllChartAct();
            }
        }
    ]);



// WEBPACK FOOTER //
// ./packages/custom/accounting/public/controllers/charts.js